<ng-container [ngTemplateOutlet]="isLoading ? spinner : mainContent"></ng-container>

<ng-template #mainContent>
<h1 mat-dialog-title>NOTAMS</h1>
<mat-dialog-content>
      <!-- <div class="notams__container">
        <div class="notams__location_container">
          <div class="notams__location">Location: <span class="notams__text-value">{{ airport.faaId }}</span></div>
          <a class="notams__faalink" target="_blank" href="https://notams.aim.faa.gov/notamSearch/">FAA NOTAM Search Site</a>
        </div>
        <div class="notams__countline">NOTAM count: <span class="notams__text-value">{{airport.notamCount}}</span> <span class="notams__fulllisttext">Partial list shown. Expand to see full list <span class="notams__urltext" (click)="showAllNotams()">HERE</span>.</span></div>
      </div> -->
      <table class="data-block data-block--lg">
        <thead>
        <tr>
          <th class="notams__column-number">Number:</th>
          <th class="notams__column-date">Start Date:<br />(UTC)</th>
          <th class="notams__column-date">End Date:<br />(UTC)</th>
          <th class="notams__column-condition">Condition:</th>
        </tr>
        </thead>
        <tbody>
        <tr class="data-block__item" *ngFor="let notam of notams; let i = index">
          <td class="notams__data-value-number">
            {{ notam.notamId }}
          </td>
          <td class="notams__data-value">
            {{ notam.effectiveDate | date: 'MM/dd/yyyy HHmm' }}
          </td>
          <td class="notams__data-value">
            {{ notam.expirationDate | date: 'MM/dd/yyyy HHmm' }}
          </td>
          <td class="notams__data-value-condition">
            <span class="reviews__review-body" [textContent]="notam.report"></span>
          </td>
        </tr>
        </tbody>
      </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="mat-raised-button" (click)="cancel()">Close</button>
</mat-dialog-actions>
</ng-template>

<ng-template #spinner>
  <mat-dialog-content>
    <div id="spinnerContainer" *ngIf="isLoading">
      <mat-dialog-content>
        <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
      </mat-dialog-content>
    </div>
  </mat-dialog-content>
</ng-template>
